/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NftOwnership,
    NftOwnershipFromJSON,
    NftOwnershipFromJSONTyped,
    NftOwnershipToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetUserRedeemableNftOwnershipsResponse
 */
export interface GetUserRedeemableNftOwnershipsResponse {
    /**
     * 
     * @type {Array<NftOwnership>}
     * @memberof GetUserRedeemableNftOwnershipsResponse
     */
    lootboxes: Array<NftOwnership>;
    /**
     * 
     * @type {Array<NftOwnership>}
     * @memberof GetUserRedeemableNftOwnershipsResponse
     */
    xpMultipliers: Array<NftOwnership>;
    /**
     * 
     * @type {string}
     * @memberof GetUserRedeemableNftOwnershipsResponse
     */
    xpMultiplierNftTrackerId: string;
}

export function GetUserRedeemableNftOwnershipsResponseFromJSON(json: any): GetUserRedeemableNftOwnershipsResponse {
    return GetUserRedeemableNftOwnershipsResponseFromJSONTyped(json, false);
}

export function GetUserRedeemableNftOwnershipsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserRedeemableNftOwnershipsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lootboxes': ((json['lootboxes'] as Array<any>).map(NftOwnershipFromJSON)),
        'xpMultipliers': ((json['xpMultipliers'] as Array<any>).map(NftOwnershipFromJSON)),
        'xpMultiplierNftTrackerId': json['xpMultiplierNftTrackerId'],
    };
}

export function GetUserRedeemableNftOwnershipsResponseToJSON(value?: GetUserRedeemableNftOwnershipsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lootboxes': ((value.lootboxes as Array<any>).map(NftOwnershipToJSON)),
        'xpMultipliers': ((value.xpMultipliers as Array<any>).map(NftOwnershipToJSON)),
        'xpMultiplierNftTrackerId': value.xpMultiplierNftTrackerId,
    };
}


